import React, { PureComponent, createRef } from 'react'
import { DESKTOP_TARGET } from './constants'
import { attachVideo } from './attach-video'
import { useDesktop } from './use-desktop'
import {
  FeatureVideoWrapper,
  Video,
} from './FeatureVideo.elements'

type Props = {
  mobileUrl: string
  mobileWidth: number
  mobileHeight: number
  mobileFallbackUrl: string
  desktopUrl: string
  desktopWidth: number
  desktopHeight: number
  desktopFallbackUrl: string
}

type State = {
  minHeight: number
}

export class FeatureVideo extends PureComponent<Props> {
  targetType: 'desktop' | 'mobile'
  source: HTMLSourceElement
  videoRef = createRef<HTMLVideoElement>()

  state: State = {
    minHeight: this.props.desktopHeight
  }

  componentDidMount() {
    this.attachVideo()
    window.addEventListener('resize', this.handleResize)
    this.resetMinHeight()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  attachVideo = (): HTMLVideoElement | undefined => {
    const { current: video } = this.videoRef
    if (!video) return

    const result = attachVideo({
      ...this.props,
      video: this.videoRef.current
    })
    if (!result) return

    this.source = result.source
    this.targetType = result.targetType
    this.videoRef.current?.load()

    return result.video
  }

  removeCurrentVideo = () => {
    const { current: video } = this.videoRef
    if (!video || !this.source) return
    this.source.remove()
  }

  resetMinHeight = () => {
    const { desktopHeight, mobileHeight } = this.props
    this.setState({
      minHeight: useDesktop() ? desktopHeight : mobileHeight
    })
  }

  handleResize = () => {
    const hasDesktopVideo = this.targetType === DESKTOP_TARGET
    const matchDesktopSize = window.matchMedia( "(min-width: 769px)" ).matches
    const hasChanged = hasDesktopVideo && !matchDesktopSize || !hasDesktopVideo && matchDesktopSize

    if (hasChanged) {
      this.removeCurrentVideo()
      const video = this.attachVideo()
      video?.load()
      video?.play()
      this.resetMinHeight()
    }
  }

  render() {
    const { minHeight } = this.state

    return (
      <FeatureVideoWrapper minHeight={minHeight}>
        <Video
          ref={this.videoRef}
          preload="metadata"
        >
          <track kind="captions" src="" />
        </Video>
      </FeatureVideoWrapper>
    )
  }
}
